// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.icon[data-v-33842614]\n{\n  position: static;\n  font-size: 120%;\n}\n.level-0[data-v-33842614]\n{\n}\n.level-1[data-v-33842614]\n{\n  background: yellow;\n}\n.level-2[data-v-33842614]\n{\n  background: orange;\n}\n.level-3[data-v-33842614]\n{\n  background: LightPink;\n}\n.level-4[data-v-33842614]\n{\n  background: LightGray;\n}\n", ""]);
// Exports
module.exports = exports;
